<div ngbDropdown class="d-inline-block" id="login-form">
  <button class="btn btn-success d-none d-lg-inline-block" id="drpLoginSignup" (click)="ShowLoginModal();">Log In / Sign Up</button>
  <button class="btn btn-success btn-sm d-inline-block d-lg-none" id="drpLoginSignup" (click)="ShowLoginModal();">Log In</button>
</div>
